import ListCell from '../ListCell/ListCell';
import styles from './ListView.module.scss';
import { users } from '../../usersConfig';

const countryMapping = {
  GBR: {
    flag: 'en',
    countryName: 'United Kingdom',
  },
  IND: {
    flag: 'hi',
    countryName: "India",
  },
  KSA: {
    flag: 'ar',
    countryName: "Saudi Arabia",
  },
  BRA: {
    flag: 'br',
    countryName: "Brazil",
  },
  RSA: {
    flag: 'za',
    countryName: "South Africa",
  },
  TUR: {
    flag: 'tr',
    countryName: "Turkey",
  },
  VNM: {
    flag: 'vn',
    countryName: "Vietnam",
  },
  VIP: {
    flag: 'vip',
    countryName: 'VIP',
  },
};

const ListView = ({ onItemClick, className = '' }) => {
  const usersList = Object.values(users).map(user => {
    const { id, login, password, userName } = user;
    const {countryName = '', flag = ''} = countryMapping[user.country] || {};

    return {
      id,
      avatar: `/avatars/${user.country?.toLowerCase()}.png`,
      name: userName,
      login,
      password,
      country: countryName,
      flag: `/${flag}.svg`,
    };
  });

  return (
    <div className={`${styles.list} ${className}`}>
      {usersList.map((item) => (
        <ListCell
          key={item.id}
          avatar={item.avatar}
          name={item.name}
          country={item.country}
          flag={item.flag}
          onClick={() => onItemClick?.(item)}
        />
      ))}
    </div>
  );
};

export default ListView;
